export const DATE_RA_TYPE = 'date';
export const EMAIL_RA_TYPE = 'email';
export const PHONE_RA_TYPE = 'phone';
export const QUESTION_RA_TYPE = 'question';
export const TERMS_RA_TYPE = 'terms';
